import React from 'react';
import {BRCustomizedTooltip as Tooltip} from "../accents/BRCustomizedTooltip";
import InfoSharpIcon from "@material-ui/icons/InfoSharp";
import {Col, Row} from "reactstrap";
import RiskComparisonFactBar from "./RiskComparisonFactBar";
import EarlyAccessWrapper from "../settings/EarlyAccessWrapper";
import Widget from "../../prefabricated/Widget";
import {useSelector} from "react-redux";
import {bbFindEntityWithinPortfolioOrSelf} from "../../../util/bbHelpers";

const BRRiskBenchMarkWidget = ({props})=>{

    const { customers, customerInView} = useSelector(({customer}) => customer);
    const {authUser,} = useSelector(({auth}) => auth);
    const {entityInView, portfolios, selfEntityId} = useSelector(({breachrisk}) => breachrisk);
    const customerIdToUse = customers ? customerInView ? customerInView : null : null;

    const myEntity = bbFindEntityWithinPortfolioOrSelf(entityInView, portfolios, customerIdToUse);

    const responsivenessData = myEntity
    && myEntity.last_cycle
    && myEntity.last_cycle.vector_summary
    && myEntity.last_cycle.vector_summary.high_risk_vector_responsiveness
        ? myEntity.last_cycle.vector_summary.high_risk_vector_responsiveness
        : null;

    const responsivenessAvg = responsivenessData && responsivenessData.average_days_since_discovery;
    const responsivenessMin = responsivenessData && responsivenessData.minimum_days_since_discovery;
    const responsivenessMax = responsivenessData && responsivenessData.maximum_days_since_discovery;

    return(<Widget styleName={`p-2 px-3 pb-4 animated fadeIn animation-duration-5 dataTile tourWidgetBenchmarks`} >
            <Tooltip disableFocusListener
                     title={"Context matters, and defenders all face similar challenges. How does this organization compare to others?"}>
                <InfoSharpIcon style={{fontSize: "20px", marginLeft: "auto", marginTop: 0, zIndex: 5}}
                               className={`text-muted`}/>
            </Tooltip>
            <div className="row"  id={""}>
                <div className={"col-12"}>
                    <h1 className={"text-center"}>Risk Benchmarks</h1>


                </div>
            </div>
            <Row>
                <Col>
                    <RiskComparisonFactBar
                        small
                        avgVarName = "breachrisk_average"
                        thisEntityVarName = "score"
                        factName = "BreachRisk™ Score"
                        forcedMaxValue = {10}
                        toolTipDescription={`The organization's BreachRisk™ Score - compared to the global average. Lower risk is better.`}


                    />
                </Col>
            </Row>
            <Row>
                <Col>
                    <RiskComparisonFactBar
                        small
                        avgVarName = "likelihood_average"
                        thisEntityVarName = "scored_vector_likelihood_score"
                        factName = "Breach Likelihood"
                        forcedMaxValue = {5}
                        toolTipDescription={`The likelihood that attackers can use detected threats to cause a breach - compared to the global average. Lower likelihood is better.`}

                    />
                </Col>
            </Row>
            <Row>
                <Col>
                    <RiskComparisonFactBar
                        small
                        avgVarName = "impact_average"
                        thisEntityVarName = "scored_vector_impact_score"
                        factName = "Breach Impact"
                        forcedMaxValue = {5}
                        toolTipDescription={`The impact attackers could make using detected threats - compared to the global average. Lower impact is better.`}


                    />
                </Col>
            </Row>
            <EarlyAccessWrapper hideVisibleWrapper>
                <Row>
                    <Col>
                        <RiskComparisonFactBar
                            small
                            // boxplot
                            hideChart = {!responsivenessData || !responsivenessMax || !responsivenessMin || !responsivenessAvg}
                            avgValue = {responsivenessAvg} //{4.0} //{responsivenessAvg}
                            maxValue = {responsivenessMax} //{148} //{responsivenessMax}
                            minValue = {responsivenessMin} //{1} //{responsivenessMin}
                            // averageDisplayName = {"Avg Response"}
                            // thisEntityVarName = "scored_vector_impact_score"
                            factName = "Threat Response"
                            // forcedMaxValue = {5}
                            colorThresholdDict = {{
                                lowest: 2,
                                low: 7,
                                medium: 28,
                                high: 60
                            }} //what values to use for lowest, low, medium, high, very high color
                            colorThresholdValue = {responsivenessAvg}
                            toolTipDescription={"The time it takes this organization to eliminate high risk threat vectors."}
                            valueUnit={"days"}

                        />
                    </Col>
                </Row>
            </EarlyAccessWrapper>
        </Widget>
    )
}

export default BRRiskBenchMarkWidget;